
import React, { useEffect, useState } from "react";
import { Loader } from "./Loader";

export const SmartFilterBar = ({ BeURL, onChange, initialFilters = {} }) => {
    const [search, setSearch] = useState(initialFilters.search || "");
    const [departments, setDepartments] = useState([]);
    const [levels, setLevels] = useState([]);
    const [courses, setCourses] = useState([]);

    const [department, setDepartment] = useState(initialFilters.department || "");
    const [level, setLevel] = useState(initialFilters.level || "");
    const [sortBy, setSortBy] = useState(initialFilters.sortBy || "latest");
    const [selectedCourses, setSelectedCourses] = useState(
        (initialFilters.courses && initialFilters.courses.split(",")) || []
    );
    const [startDate, setStartDate] = useState(initialFilters.startDate || "");
    const [endDate, setEndDate] = useState(initialFilters.endDate || "");

    // load options
    useEffect(() => {
        let mounted = true;
        const load = async () => {
            try {
                const res = await fetch(`${BeURL}/admin/filter-options`, {
                    credentials: "include",
                });
                const data = await res.json();
                if (!mounted) return;
                if (data.success) {
                    setDepartments(data.departments || []);
                    setLevels(data.levels || []);
                    setCourses(data.courses || []);
                }
            } catch (err) {
                console.error("Error in smart filter", err);
            }
        };
        load();
        return () => { mounted = false; };
    }, [BeURL]);

    // debounce + emit
    useEffect(() => {
        const t = setTimeout(() => emitFilter(), 400);
        return () => clearTimeout(t);
        // eslint-disable-next-line
    }, [search, department, level, sortBy, selectedCourses, startDate, endDate]);

    const emitFilter = () => {
        const filters = {
            search: search || "",
            department: department || "",
            level: level || "",
            sortBy: sortBy || "latest",
            courses: selectedCourses.length ? selectedCourses.join(",") : "",
            startDate: startDate || "",
            endDate: endDate || "",
        };

        // url sync
        const qs = new URLSearchParams(filters).toString();
        const newUrl = qs ? `?${qs}` : window.location.pathname;
        window.history.replaceState(null, "", newUrl);

        onChange(filters);
    };

    const clearFilters = () => {
        setSearch("");
        setDepartment("");
        setLevel("");
        setSortBy("latest");
        setSelectedCourses([]);
        setStartDate("");
        setEndDate("");
        // emit immediately
        setTimeout(() => emitFilter(), 0);
    };

    // active filter chips for UI
    const activeChips = [];
    if (search) activeChips.push({ key: "search", label: `Search: "${search}"` });
    if (department) activeChips.push({ key: "department", label: department });
    if (level) activeChips.push({ key: "level", label: level });
    if (selectedCourses.length) activeChips.push({ key: "courses", label: `${selectedCourses.length} course(s)` });
    if (startDate || endDate) activeChips.push({ key: "date", label: `${startDate || "Anywhere"} → ${endDate || "Anywhere"}` });
    if (sortBy && sortBy !== "latest") activeChips.push({ key: "sortBy", label: `Sort: ${sortBy}` });

      if(!courses){
        return <div><Loader /></div>
      }

    return (
        <div className="bg-white rounded-xl shadow p-4 mb-4">
            <div className="flex flex-wrap items-center gap-3">
                <input
                    type="text"
                    placeholder="Search student / email / course..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="border px-3 py-2 rounded-lg text-sm w-[240px]"
                />

                <select value={department} onChange={(e) => setDepartment(e.target.value)} className="border px-3 py-2 rounded-lg text-sm">
                    <option value="">All Departments</option>
                    {departments.map((d, i) => <option key={i} value={d.department}>{d.department}</option>)}
                </select>

                <select value={level} onChange={(e) => setLevel(e.target.value)} className="border px-3 py-2 rounded-lg text-sm">
                    <option value="">All Levels</option>
                    {levels.map((l, i) => <option key={i} value={l}>{l}</option>)}
                </select>

                <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} className="border px-3 py-2 rounded-lg text-sm">
                    <option value="latest">Latest First</option>
                    <option value="oldest">Oldest First</option>
                    <option value="priceHigh">Price: High → Low</option>
                    <option value="priceLow">Price: Low → High</option>
                </select>

                <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="border px-2 py-2 rounded-lg text-sm" />
                <span className="text-xs text-gray-500">to</span>
                <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="border px-2 py-2 rounded-lg text-sm" />

                <button onClick={clearFilters} className="ml-2 text-sm bg-gray-100 px-3 py-2 rounded">Clear</button>
            </div>

        </div>
    );
};